import api from "@/api/api";

export const getUser = (userId) => {
  return api.get(`/users/${userId}`);
};

export const getUserUsage = () => {
  return api.get(`/users/me/usage`);
};

export const sendQuiz = () => {
  return Promise.resolve({});
  // return api.post("/users/me/quiz", payload);
};

export const updateUser = (payload) => {
  return api.patch("/users/me", payload);
};

export const getUserOauthProfiles = (userId) => {
  return api.get(`/users/${userId}/oauth-profiles`);
};

export const deleteUserOauthProfile = (userId, profileId) => {
  return api.delete(`/users/${userId}/oauth-profiles/${profileId}`);
};
